import React, { useEffect, useState } from 'react';

import { usePeriodPickerQueries } from '@entities/period-picker/lib/usePeriodPickerQueries';
import { PickerTitle } from '@entities/period-picker/model/picker-title.enum';
import { useCalendarQueries } from '@entities/сalendar/lib/useCalendarQueries';
import { DateHelpers } from '@shared/helpers';

import { useSetCalendarRangeInFirstRender } from '.';
import { TCalendarRange, TPickerId } from '../../model/types';

interface IUsePeriodPickerProps {
    calendarRange: TCalendarRange;
    setCalendarRange: React.Dispatch<React.SetStateAction<TCalendarRange>>;
}

export const usePeriodPicker = ({ calendarRange, setCalendarRange }: IUsePeriodPickerProps) => {
    const [periodInput, setPeriodInput] = useState('');
    const { setDateRangeQueryValues } = useCalendarQueries();
    const { periodPickerQueryValue, setPeriodPickerQueryValue } = usePeriodPickerQueries();
    const { currentPickerId } = useSetCalendarRangeInFirstRender({ setCalendarRange });
    // логика дебаунса (оставил, на случай если передумают)
    // const debounceTimer = useRef<number>(null);

    const {
        parsePeriodString,
        getThisMonthPeriod,
        getPreviousMonthPeriod,
        getPreviousWeekPeriod,
        getCurrentQuarterPeriod,
        getPreviousSevenDays,
        dateFormatter,
        isDateValid,
    } = DateHelpers;

    // логика дебаунса (оставил, на случай если передумают)
    // const clearDebounce = () => {
    //     if (debounceTimer.current !== null) {
    //         window.clearTimeout(debounceTimer.current);
    //         debounceTimer.current = null;
    //     }
    // };

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!periodPickerQueryValue) {
            setCalendarRange([null, null]);
            setPeriodInput('');
        }
        if (periodPickerQueryValue === PickerTitle.PREVIOUS_SEVEN_DAYS) {
            setCalendarRange(getPreviousSevenDays());
        }
    }, [periodPickerQueryValue, getPreviousSevenDays, setCalendarRange]);

    // логика дебаунса (оставил, на случай если передумают)
    // useEffect(() => {
    //     clearDebounce();
    // }, [periodPickerQueryValue]);

    const handlePeriodInputChange = (value: string) => {
        setPeriodInput(value);
        // логика дебаунса (оставил, на случай если передумают)
        // clearDebounce();
        // if (periodPickerQueryValue === PickerTitle.CHOOSE_PERIOD) {
        //     // логика дебаунса (оставил, на случай если передумают)
        //     // const scheduledValue = value;
        //     // debounceTimer.current = window.setTimeout(() => {
        //     //     if (periodPickerQueryValue === PickerTitle.CHOOSE_PERIOD) {
        //     //         const range = parsePeriodString(value);
        //     //         setCalendarRange(parsePeriodString(scheduledValue));
        //     //         setDateRangeQueryValues(range);
        //     //     }
        //     // }, 1500);
        //     // return;
        //     if (periodPickerQueryValue === PickerTitle.CHOOSE_PERIOD) {
        //         // const range = parsePeriodString(value);
        //         setCalendarRange(parsePeriodString(value));
        //         // setDateRangeQueryValues(range);
        //     }
        // }
        // setCalendarRange(parsePeriodString(value));
    };

    const onChangeRangeQueryValues = (raw?: string) => {
        if (periodPickerQueryValue !== PickerTitle.CHOOSE_PERIOD) return;

        const [startD, endD] = calendarRange;

        const source = (raw ?? '').trim();
        if (source) {
            const [rawStart = '', rawEnd = ''] = source.split('-').map((s) => s.trim());
            const validStart = isDateValid(rawStart);
            const validEnd = isDateValid(rawEnd);

            if (!validStart && !validEnd) return;

            const finalEnd = validEnd ? rawEnd : rawStart;
            const normalized = `${rawStart} - ${finalEnd}`;

            setPeriodInput(normalized);
            const parsed = parsePeriodString(normalized);
            setCalendarRange(parsed);
            setDateRangeQueryValues(parsed);
            return;
        }

        if (startD && endD) {
            const [start, end] = [startD, endD].map((d) => dateFormatter({ date: d! }));
            const normalized = `${start} - ${end}`;
            setPeriodInput(normalized);
            const parsed = parsePeriodString(normalized);
            setDateRangeQueryValues(parsed);
        }
    };

    const handleClickPicker = (pickerId: TPickerId) => {
        // clearDebounce();
        void setPeriodPickerQueryValue(pickerId);

        if (pickerId === PickerTitle.CHOOSE_PERIOD) {
            return;
        }
        setPeriodInput('');
        if (pickerId === PickerTitle.CURRENT_MONTH) {
            setCalendarRange(getThisMonthPeriod());
            setDateRangeQueryValues(getThisMonthPeriod());
        }
        if (pickerId === PickerTitle.PREVIOUS_MONTH) {
            setCalendarRange(getPreviousMonthPeriod());
            setDateRangeQueryValues(getPreviousMonthPeriod());
        }
        if (pickerId === PickerTitle.PREVIOUS_WEEK) {
            setCalendarRange(getPreviousWeekPeriod());
            setDateRangeQueryValues(getPreviousWeekPeriod());
        }
        if (pickerId === PickerTitle.CURRENT_QUARTER) {
            setCalendarRange(getCurrentQuarterPeriod());
            setDateRangeQueryValues(getCurrentQuarterPeriod());
        }
        if (pickerId === PickerTitle.PREVIOUS_SEVEN_DAYS) {
            setCalendarRange(getPreviousSevenDays());
            setDateRangeQueryValues(getPreviousSevenDays());
        }
    };

    return {
        currentPickerId,
        periodInput,
        periodPickerQueryValue,
        onChangeRangeQueryValues,
        handleClickPicker,
        handlePeriodInputChange,
    };
};
